const config: siteConfig = {
  // Softdigi endpoint
  API_URL: "/api/api",
  REDIRECT_SESSION_KEY: "",
  CLIENT_URL: "http://127.0.0.1:5000",
};

export default config;
